import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  jabfungrowtableChannel = new Subject();
  SyncronizeChannel = new Subject();
  inactiveChannel = new Subject();
  activeChannel = new Subject();
  fetchgetuserpkpmChannel = new Subject()
  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.inactiveChannel.next({ status: apiResponse.INITIAL });
    this.activeChannel.next({ status: apiResponse.INITIAL });
    this.jabfungrowtableChannel.next({ status: apiResponse.INITIAL });
    this.SyncronizeChannel.next({ status: apiResponse.INITIAL });
    this.fetchgetuserpkpmChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchJabfungTable = async (query, cancelToken) => {
    try {
      this.jabfungrowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchJabfungTable(query, cancelToken)
        .then((result) => {
          this.jabfungrowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.jabfungrowtableChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  SyncronizeJabfung = async (query) => {
    try {
      this.SyncronizeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .SyncronizeJabfung(query)
        .then((result) => {
          this.SyncronizeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.SyncronizeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", error);
    }
  };

  fetchInactive = async (query) => {
    try {
      this.inactiveChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchInactive(query)
        .then((result) => {
          this.inactiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchActive = async (query) => {
    try {
      this.activeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchActive(query)
        .then((result) => {
          this.activeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.activeChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchgetuserpkpm = async (query) => {
    try {
      this.fetchgetuserpkpmChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchgetuserpkpm(query)
        .then((result) => {
          this.fetchgetuserpkpmChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.fetchgetuserpkpmChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", error);
    }
  };
}

export default DataTableBloc;
